export enum TipoCargosChapa {
  Desconhecido = 'DESCONHECIDO',
  Presidente = 'PRESIDENTE',
  Vice_Presidente = 'VICE_PRESIDENTE',
  Conselheiro = 'CONSELHEIRO'
}